import { NintendoSwitchIcon } from './NintendoSwitchIcon';

/**
 * author: Contributors
 * id D57C5D23-1122-4DEB-BEC4-77D5A4D685FE
 * name nintendo-switch
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/nintendo-switch.svg
 * tags
 * - Brand / Logo 
 */
export const NintendoSwitchOnlineIcon = NintendoSwitchIcon;
export default NintendoSwitchOnlineIcon